import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { scheduledPatientInformationAtom } from '../schedule-preview/state';
import { inSessionPatientInformationAtom, selectedClientInfoAtom } from '../state';

/**
 * Resolves appointment and patient short IDs for the selected client from
 * in-session and scheduled state.
 */
export function useSelectedClientAppointmentIds() {
  const selectedPatientInfo = useAtomValue(selectedClientInfoAtom);
  const inSessionPatientInfo = useAtomValue(inSessionPatientInformationAtom);
  const scheduledPatientInfo = useAtomValue(scheduledPatientInformationAtom);

  return useMemo(() => {
    const patientShortId = selectedPatientInfo?.patientShortId || scheduledPatientInfo?.patientShortId || '';
    const inSessionAppointmentShortId =
      inSessionPatientInfo?.patientShortId === patientShortId
        ? inSessionPatientInfo.inSessionAppointmentShortId
        : undefined;
    const scheduledAppointmentShortId =
      scheduledPatientInfo?.patientShortId === patientShortId ? scheduledPatientInfo.appointmentShortId : undefined;
    const appointmentShortId =
      selectedPatientInfo?.inSessionAppointmentShortId || inSessionAppointmentShortId || scheduledAppointmentShortId;

    return { appointmentShortId, patientShortId };
  }, [inSessionPatientInfo, scheduledPatientInfo, selectedPatientInfo]);
}
